import React from "react";

import { NoticeForm } from "pages/notice/NoticeForm";
import { createNotice } from "shared/api/NoticeApi";

// 등록 폼 초기값(빈 값). 모듈 상수로 둬 NoticeForm이 1회만 초기화하도록 안정 참조 유지.
const EMPTY_INITIAL = {
  title: "",
  pin: false,
  files: [],
  image: null,
  content: "",
  engTitle: "",
  engContent: "",
};

const CreateNoticePage = () => (
  <NoticeForm
    mode="create"
    initialValues={EMPTY_INITIAL}
    onSubmit={(data) => createNotice(data)}
  />
);

export default CreateNoticePage;
